/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_Single_VatInputs */

const vi_invoice_misa_template_single_vat = /** @type {(inputs: Invoice_Misa_Template_Single_VatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một mức VAT`)
};

/**

* @param {Invoice_Misa_Template_Single_VatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_single_vat = /** @type {((inputs?: Invoice_Misa_Template_Single_VatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_Single_VatInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_single_vat(inputs)
});